import { z } from "zod";
import { DEMO_DICTATION_TRANSCRIPT_MAX_CHARS, DictationSegmentSchema, } from "./encounter-documentation.js";
import { IdSchema, IsoDateTimeSchema } from "./primitives.js";
/**
 * Short-lived server backup of a dictation that has not been inserted into the note yet
 * (api.save_dictation_backup). It expires 24 hours after its last save.
 */
export const SaveDictationBackupRequestSchema = z
    .object({
    transcript: z.string().min(1).max(DEMO_DICTATION_TRANSCRIPT_MAX_CHARS),
    segments: z.array(DictationSegmentSchema).min(1).max(2_000),
})
    .strict();
export const DictationBackupReceiptSchema = z
    .object({
    encounterId: IdSchema,
    savedAt: IsoDateTimeSchema,
    expiresAt: IsoDateTimeSchema,
})
    .strict();
export const DictationBackupSchema = DictationBackupReceiptSchema.extend({
    transcript: z.string().min(1).max(DEMO_DICTATION_TRANSCRIPT_MAX_CHARS),
    segments: z.array(DictationSegmentSchema).min(1).max(2_000),
}).strict();
export const DictationBackupDeleteReceiptSchema = z
    .object({ encounterId: IdSchema, deleted: z.boolean() })
    .strict();
//# sourceMappingURL=dictation-backup.js.map